
import React, { useEffect, useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import Main from './pages/main';
import { checkUserAccountExists, getDesktopAppsUrl, getTopCatalogsURL, getTrendingSearchUrl, notificationsStreamApi } from './utils/constants';
import { useDispatch } from 'react-redux';
import DesktopNotifications from './components/Notifications/DesktopNotifications/DesktopNotifications';
import Settings from './components/Settings/Settings';
import SearchApps from './components/AppsList/SearchApps/SearchApps';
import TicketStatus from './components/TicketStatus/TicketStatus';
import RaiseTicket from './components/RaiseTicket/RaiseTicket';
import { HeaderButton } from '../../../application/commons/headers/headers';
import { updateTrendingSearches } from '../../../utils/redux-store/slices/searchSlice';
import { updateNotifications } from '../../../utils/redux-store/slices/desktopNotificationSlice';
import { updateDesktopApps } from '../../../utils/redux-store/slices/desktopAppsSlice';
import Loading from '../../../application/commons/loading/loading';
import PrivacyPolicy from '../../../application/commons/privacy-policy/privacy-policy';
import UserProfile from '../../../application/commons/UserProfile/UserProfile';
import ResetPassword from '../../../application/commons/reset-password/reset.password';
import UpdateHeaders from '../../../application/commons/update-headers/update.headers';
import { DropdownLinks } from '../../../application/commons/drop-down/drop-down.menu';
import KbList from './components/KbList/KbList';
import KbArticle from './components/KbArticle/KbArticle';
import Error404 from '../../../application/pages/error404';
import LiveAgentWebChat from '../../../application/commons/live-agent/LiveAgentWebChat';
import { useSelector } from 'react-redux';
import RaiseCatalog from './components/AppsList/Catalog/RaiseCatalog/RaiseCatalog';
import { updateAccountExist, updateCatalogs } from '../../../utils/redux-store/slices/serviceNowSlice';
import { useTheme } from '@mui/material';
import { tokens } from '../../../theme';

const DesktopRoutes: React.FC<DesktopLayoutProps> = ({ redirectUrl }) => {
    const [loading, setLoading] = useState(true);
    const userProfile = useSelector((store: any) => store.login.loginDetails);

    
    const dynamicButtons: HeaderButton[] = [
         { id: "ticket_status", },
        { id: "notifications" },
        { id: "support", position: 1 }
    ];

    const profileItems: DropdownLinks[] = [
        {
            id: "settings"
        }
    ]

    useEffect(() => {
        getTrendingSearches();
        getDesktopApps();
    }, [])

    useEffect(() => {
        checkIfUserAccountExists()
    }, [userProfile])

    useEffect(() => {
        const eventSource = new EventSource(`${notificationsStreamApi}?emailId=${userProfile.email}`);

        eventSource.onmessage = (event) => {
            const updatedNotifications: any = JSON.parse(event.data);
            dispatch(updateNotifications({
                notifications: updatedNotifications
            }));
        };
        eventSource.onerror = () => {
            console.error('EventSource connection error.');
            eventSource.close();
        };

        return () => {
            eventSource.close();
        };
    }, [userProfile.email]);

    const dispatch = useDispatch();

    const getTrendingSearches = async () => {
        try {
            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            const result = await (await fetch(getTrendingSearchUrl, options)).json();
            if (result) {
                dispatch(updateTrendingSearches({ value: result }));
            }
        } catch (err) {
            console.log('ERROR :::', err);
            dispatch(updateTrendingSearches({ value: [] }));
        }
    }

    const checkIfUserAccountExists = async () => {
        try {
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            };
            const result = await (await fetch(`${checkUserAccountExists}?email=${userProfile.email}`, options)).json();
            if (result) {
                dispatch(updateAccountExist({ value: result }));
                getTopCatalogList();
            } else {
                dispatch(updateAccountExist({ value: false }));
            }
        } catch (err) {
            dispatch(updateAccountExist({ value: false }));
            console.log("ERROR :::", err);
        }
    }

    const getDesktopApps = async () => {
        try {
            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            const result = await (await fetch(getDesktopAppsUrl, options)).json();
            if (result) {
                dispatch(updateDesktopApps({ value: result }));
            }
        } catch (err) {
            console.log('ERROR :::', err);
            dispatch(updateDesktopApps({ value: [] }));
        }
        setTimeout(() => setLoading(false), 2000);
    }


    const getTopCatalogList = async () => {
        try {
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            };
            const result = await (await fetch(getTopCatalogsURL, options)).json();
            if (result) {
                dispatch(updateCatalogs({ value: result }))
            }
        } catch (err) {
            dispatch(updateCatalogs({ value: [] }))
            console.log("ERROR :::", err);
        }
    };


    if (loading) {
        return <Loading />
    }


    return (
        <div>
            <Routes>
                <Route path="/" element={<><DesktopLayout redirectUrl={redirectUrl + '/desktop'} /><UpdateHeaders redirectUrl={redirectUrl} headersDynamicButtons={dynamicButtons} userProfileItems={profileItems} defaultUserProfileItemsOverride={[]} /></>} >
                    <Route index element={<DesktopHome redirectUrl={redirectUrl} />} />
                    <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                    <Route path='/notifications' element={<DesktopNotifications />} />
                    <Route path='/user-profile' element={<UserProfile />} />
                    <Route path='/settings' element={<Settings />} />
                    <Route path='/apps' element={<SearchApps />} />
                    <Route path='/raise-ticket' element={<RaiseTicket />} />
                    <Route path='/raise-catalog' element={<RaiseCatalog />} />
                    <Route path='/ticket-status' element={<TicketStatus />} />
                    <Route path='/reset-password' element={<ResetPassword />} />
                    <Route path='/live-Agent' element={<LiveAgentWebChat bot='B0026' />} />
                    <Route path='/kb-list' element={<KbList />} />
                    <Route path='/kb-article' element={<KbArticle />} />
                    <Route path="*" element={<Error404 />} />
                </Route>
            </Routes>
        </div>
    );
};

// Home component for /user
const DesktopHome: React.FC<DesktopLayoutProps> = ({ redirectUrl }) => {
    return (
        <>
            <Main redirectUrl={redirectUrl} />
        </>
    );
};

interface DesktopLayoutProps {
    redirectUrl: string;
}

export const DesktopLayout: React.FC<DesktopLayoutProps> = ({ redirectUrl }) => {
    const theme = useTheme(); // Access the current theme
    const colors = tokens(theme.palette.mode);

    return (
        <div className='main-page' style={{backgroundColor: theme.palette.mode === 'dark' ? 'var(--header-bg-color)' : ''}}>
            <Outlet />
        </div>
    );
};

export default DesktopRoutes;
